import {SortDirection} from "components/src/api/admin/generated";
import {NavArrowDown, NavArrowUp} from "iconoir-react";
import {Dispatch, SetStateAction} from "react";

interface SortIconProps {
    sortDirection : SortDirection,
    setSortDirection?: Dispatch<SetStateAction<SortDirection>>;
}

export const SortIcon = ({sortDirection, setSortDirection} : SortIconProps) =>
{
    function toggleSort()
    {
        if (setSortDirection !== undefined) {
            setSortDirection(sortDirection === SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc);
        }
    }

    const iconProps = {
        strokeWidth: 2,
        onClick: toggleSort,
        title: "Toggle sort",
        className: "sort-icon-chevron"
    };

    return (
        <span className="sort-icon btn btn-link p-0">
            {sortDirection === SortDirection.Asc ? <NavArrowDown {...iconProps} /> : <NavArrowUp {...iconProps} />}
        </span>
    )
}
